import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';
import { subscribeErrorModal } from '../../features/errorHandler';
import Button from '../Button/Button';
import './ErrorModal.scss';

function ErrorModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: 'Chyba',
    message: '',
  });

  useEffect(() => {
    const unsubscribe = subscribeErrorModal(({ message, title }) => {
      setModalState({
        isOpen: true,
        title: title || 'Chyba',
        message: message || 'Nastal problém pri komunikácii so serverom.',
      });
    });

    return () => unsubscribe();
  }, []);

  const handleClose = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  // Close on Escape
  useEffect(() => {
    if (!modalState.isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [modalState.isOpen]);

  // Prevent body scroll when open
  useEffect(() => {
    if (modalState.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [modalState.isOpen]);

  if (!modalState.isOpen) return null;

  return createPortal(
    <div className="error-modal__overlay" onClick={handleClose}>
      <div
        className="error-modal__card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          className="error-modal__close-btn"
          onClick={handleClose}
          aria-label="Zatvoriť"
        >
          <X size={18} />
        </button>

        <div className="error-modal__icon-wrapper">
          <AlertTriangle size={28} className="error-modal__icon" />
        </div>

        <h3 className="error-modal__title">{modalState.title}</h3>
        <p className="error-modal__message">{modalState.message}</p>

        <div className="error-modal__actions">
          <Button variant="primary" onClick={handleClose} className="error-modal__btn">
            Rozumiem
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ErrorModal;
